export default __webpack_public_path__ + "static/media/mdi_download.e6052fa8.svg";